import { Navigate, useLocation } from "react-router-dom";
import { CUSTOMER_WEB_URL } from "../api/apiConfig";
import { canAccessRoute, isAdminPortalRole, normalizeRole } from "../config/permissions";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, allowedRoles = [], routeKey = "" }) {
  const { user, authReady } = useAuth();
  const location = useLocation();

  if (!authReady) {
    return null;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const role = normalizeRole(user.role);

  if (!isAdminPortalRole(role)) {
    window.location.replace(CUSTOMER_WEB_URL);
    return null;
  }

  if (routeKey && !canAccessRoute(role, routeKey)) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (user.mustChangePassword && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }

  return children;
}
